"use client";

import { useEffect, useState } from "react";
import { Box, Text, Flex, Divider } from "@chakra-ui/react";

export function CountdownTimer({ endDate }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = endDate.getTime() - new Date().getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  return (
    <Box textAlign="center" w="full">
      <Text
        color="blue.200"
        mt={10}
        fontFamily={'"Geist", sans-serif'}
        fontSize={{ base: "sm", md: "lg" }}
      >
        Contest Ends:
      </Text>

      <Flex direction="column" align="center">
        <Flex justify="center" align="flex-end" gap={{ base: 6, md: 10 }}>
          <Box textAlign="center">
            <Text
              fontSize={{ base: "3xl", md: "6xl" }}
              fontWeight="bold"
              color="white"
              mb={1}
              fontFamily={'"Geist", sans-serif'}
              lineHeight={1}
            >
              {timeLeft.days}
            </Text>
            <Divider mx={'auto'} borderColor="blue.400" w={{ base: 12, md: 16 }} />
            <Text
              fontSize={{ base: "xs", md: "sm" }}
              color="blue.300"
              textTransform="uppercase"
              mt={2}
              fontFamily={'"Geist", sans-serif'}
            >
              Days
            </Text>
          </Box>

          <Box textAlign="center">
            <Text
              fontSize={{ base: "3xl", md: "6xl" }}
              fontWeight="bold"
              color="white"
              mb={1}
              fontFamily={'"Geist", sans-serif'}
              lineHeight={1}
            >
              {timeLeft.hours}
            </Text>
            <Divider mx={'auto'} borderColor="blue.400" w={{ base: 12, md: 16 }} />
            <Text
              fontSize={{ base: "xs", md: "sm" }}
              color="blue.300"
              textTransform="uppercase"
              mt={2}
              fontFamily={'"Geist", sans-serif'}
            >
              Hours
            </Text>
          </Box>

          <Box textAlign="center">
            <Text
              fontSize={{ base: "3xl", md: "6xl" }}
              fontWeight="bold"
              color="white"
              mb={1}
              fontFamily={'"Geist", sans-serif'}
              lineHeight={1}
            >
              {timeLeft.minutes}
            </Text>
            <Divider mx={'auto'} borderColor="blue.400" w={{ base: 12, md: 16 }} />
            <Text
              fontSize={{ base: "xs", md: "sm" }}
              color="blue.300"
              textTransform="uppercase"
              mt={2}
              fontFamily={'"Geist", sans-serif'}
            >
              Minutes
            </Text>
          </Box>

          <Box textAlign="center">
            <Text
              fontSize={{ base: "3xl", md: "6xl" }}
              fontWeight="bold"
              color="white"
              mb={1}
              fontFamily={'"Geist", sans-serif'}
              lineHeight={1}
            >
              {timeLeft.seconds}
            </Text>
            <Divider mx={'auto'} borderColor="blue.400" w={{ base: 12, md: 16 }} />
            <Text
              fontSize={{ base: "xs", md: "sm" }}
              color="blue.300"
              textTransform="uppercase"
              mt={2}
              fontFamily={'"Geist", sans-serif'}
            >
              Seconds
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Text
        mt={2}
        fontSize={{ base: "sm", md: "md" }}
        fontFamily={'"Geist", sans-serif'}
        color="blue.100"
      >
        October 31st, 2025 at 11:59 PM CST
      </Text>
    </Box>
  );
}
